<div class="db-migration-zip-upload">
  <div class="db-migration-zip-upload__body">
    <div class="db-migration-zip-upload__title">
      <i class="db-icon db-icon-ds-arrow-small" (click)="back.emit()"></i>
      <p>
        Upload your website’s <br *ngIf="!!isMobile"><span>backup zip file</span> <br *ngIf="!isMobile"> in the specified format to initiate the migration
      </p>
    </div>
    <ng-container *ngIf="isMobile">
      <ng-container  *ngTemplateOutlet="upload"></ng-container>
    </ng-container>
    <div class="db-migration-zip-upload__steps">
      <div class="db-migration-zip-upload__step_container">
        <div class="step-title">
          <div class="step-number">
            <div>
              1
            </div>
          </div>
          Export website data
        </div>
        <div class="step-description">
          Export your website’s <span>
          <img src="assets/images/other/folder.png">
          wp-content
        </span> folder along with the <br *ngIf="!isMobile">
          <span>
          <img src="assets/images/other/file.png">database (.sql file)
        </span>
          from your current hosting platform <br *ngIf="!isMobile">
          or website management tool.
        </div>
      </div>
      <div class="db-migration-zip-upload__step_container">
        <div class="step-title">
          <div class="step-number">
            <div>
              2
            </div>
          </div>
          Create a zip file
        </div>
        <div class="step-description">
          Compress the exported data into a single zip file, making sure both are located at the same level within the
          zip file structure.
        </div>
        <div class="step-link">
          <a class="db-link-blue"
             [dsTooltip]="zip"
             [dsTooltipAlign]="'left'"
             [hostClass]="'cover-all'"
             dsTooltipPosition="top"
             dsTooltipSize="large"
             dsTooltipColor="transparent"><span>See the example</span></a>
          <ng-template #zip>
            <img class="zip-upload-image" src="assets/images/migration/zip-upload.png">
          </ng-template>
        </div>
      </div>
      <div class="db-migration-zip-upload__step_container">
        <div class="step-title">
          <div class="step-number">
            <div>
              3
            </div>
          </div>
          Upload the zip file and initiate the migration
        </div>
        <div class="step-description">
          Select the created zip file, and click the ‘Proceed’ button to upload it. Once the upload is completed, the
          migration will start automatically.
        </div>
      </div>
    </div>
    <div class="db-migration-zip-upload__notification">
      <div class="notification-icon-container">
        <i class="db-icon db-icon-ds-bell"></i>
      </div>
      <div class="notification-text">
        We’ll send you an email notification once the migration of your website is completed
      </div>
    </div>
    <div class="db-migration-zip-upload__help">
      For detailed instructions, visit our <a class="db-link-blue" target="_blank" href="https://help.10web.io/hc/en-us/articles/14826249214994"><span>Help Center article.</span></a>
    </div>
  </div>
  <ng-container *ngIf="!isMobile">
    <ng-container  *ngTemplateOutlet="upload"></ng-container>
  </ng-container>
  <ng-template #upload>
    <div class="db-migration-zip-upload__action">
      <div class="upload-wrapper">
        <label class="zip-upload-container" for="file-input">
          <a class="ds-btn zip-upload-btn">
            <i class="db-icon db-icon-ds-paperclip"></i>
            Choose file
          </a>
          <input type="file" accept=".zip" class="file-input" (change)="onChange($event)" id="file-input"/>
          <div class="zip-name">
            <img src="assets/images/other/folder.png">
            {{fileName || 'Max file size 50GB'}}
          </div>
        </label>
        <span class="zip-upload-err" *ngIf="errMessage">
          {{errMessage}}
        </span>
      </div>
      <div class="upload-agreement-action-wrapper">
        <div>
          <input type="checkbox"
                 #agreement
                 class="ds-checkbox" id="agree-checkbox">
          <label for="agree-checkbox" class="ds-checkbox-label white">
            I agree to allow 10Web to access my website content and confirm that the content in the ZIP is safe.
          </label>
        </div>
        <button class="ds-btn-white" [class.ds-btn-disabled]="!agreement.checked || errMessage || !selectedFile" (click)="uploadFile()">{{'text_proceed'|dbText}}</button>
      </div>
    </div>
  </ng-template>
</div>
